// extracted by mini-css-extract-plugin
module.exports = {"countdown":"ci","srOnly":"di"};